import { useSettings } from "~/store/settings";

const getPlatformId = () => {
	const route = useRoute();
	const store = useSettings();
	const { appType } = route.query;

	return store.isNativeApp && appType && String(appType).toUpperCase() === "IOS"
		? 3
		: store.isNativeApp && appType && String(appType).toUpperCase() === "ANDROID"
		? 4
		: store.isNativeApp && appType && String(appType).toUpperCase() === "HUAWEI"
		? 5
		: isMobile
		? 1
		: 2;
};

export default getPlatformId;
